export const subCategoryFields = ['code', 'name', 'url', 'image', 'isSetCategory', 'shortDescription'];
export const siblingCategoryFields = ['code', 'name', 'url', 'thumbnail'];

export const categoryFields = [
  'brandCorner',
  'code',
  'name',
  'url',
  'faqs',
  'description',
  'additionalMarketingDatas',
  'showChat',
  'promotion',
  'liveChatAgentConfig(FULL)',
  `subCategories(${subCategoryFields.join(',')})`,
  `siblingCategories(${siblingCategoryFields.join(',')})`,
  'metaTags',
  'image'
];
